// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// The #{TokenName}# will be replaced during the AzDO release process using AzDO variables

import { EnvironmentOptions } from './environment-options';
import { GOOGLE_PRODUCTS } from './google-products';

export const environment: EnvironmentOptions = {
  production: true,
  baseUrl: '#{baseUrl}#',
  baseCdnUrl: '#{baseCdnUrl}#',
  propertyCdnUrl: '#{propertyCdnUrl}#',
  assetOptimizationURL: '#{AssetOptimizationUrl}#',
  authCookieName: '#{AuthCookieName}#',
  authTokenName: '#{AuthTokenName}#',
  useCookie: true,
  underwriterUrl: '#{underwriterUrl}#',
  agGridLicenseKey: 'RealPage_Inc_MultiApp_1Devs2_SaaS_7_September_2018__MTUzNjI3NDgwMDAwMA==19ba64bb8eeb8a1dce779512ef96a3cb',
  paymentGatewayUrl: '#{PaymentGatewayUrl}#',
  staticFiles: 'assets',
  redirect: '#{redirect}#',

  useAnalytics: true,
  analyticsId: GOOGLE_PRODUCTS.ANALYTICS.REALPAGE_DEV_ACCOUNT,
  reCaptchaKey: GOOGLE_PRODUCTS.RECAPTCHA.SITE_KEY
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts